/* tslint:disable */
/* eslint-disable */
/**
 * Probonio full API Docs
 * If you stumbled upon this page and want to integrate Probonio into your business software [click here!](/api/external)    If you\'re looking for more information about Probonio [head over here](https://probonio.de)    **This documentation describes all Endpoints of the Probonio API. It\'s created for experienced Probonio Developers only!**   <a href=\"/openapi/logout\" target=\"_blank\"><button>     <h4>Click here to trigger a full logout from Keycloak.</h4> </button></a><br /> 
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { FitnessTransactionsHistoryDTO } from '../dto';
// @ts-ignore
import { FitnessVoucherDTO } from '../dto';
// @ts-ignore
import { ValidationErrorResponseDTO } from '../dto';
/**
 * FitnessApi - axios parameter creator
 * @export
 */
export const FitnessApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Exports Fitness Members with according Acctions in CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCSV: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/benefits/fitness/csv`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets one usc voucher for an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFitnessVoucher: async (tenantId: string, employeeId: string, voucherId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getFitnessVoucher', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('getFitnessVoucher', 'employeeId', employeeId)
            // verify required parameter 'voucherId' is not null or undefined
            assertParamExists('getFitnessVoucher', 'voucherId', voucherId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/fitness/vouchers/{voucherId}`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)))
                .replace(`{${"voucherId"}}`, encodeURIComponent(String(voucherId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistory: async (tenantId: string, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('getTransactionHistory', 'tenantId', tenantId)
            const localVarPath = `/tenants/{tenantId}/benefits/fitness/transactionHistory`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }

            if (withAggregations !== undefined) {
                localVarQueryParameter['withAggregations'] = withAggregations;
            }

            if (sortBy) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all usc vouchers for an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFitnessVouchers: async (tenantId: string, employeeId: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            assertParamExists('listFitnessVouchers', 'tenantId', tenantId)
            // verify required parameter 'employeeId' is not null or undefined
            assertParamExists('listFitnessVouchers', 'employeeId', employeeId)
            const localVarPath = `/tenants/{tenantId}/employees/{employeeId}/benefits/fitness/vouchers`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)))
                .replace(`{${"employeeId"}}`, encodeURIComponent(String(employeeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FitnessApi - functional programming interface
 * @export
 */
export const FitnessApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FitnessApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Exports Fitness Members with according Acctions in CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCSV(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCSV(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets one usc voucher for an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFitnessVoucher(tenantId: string, employeeId: string, voucherId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FitnessVoucherDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFitnessVoucher(tenantId, employeeId, voucherId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getTransactionHistory(tenantId: string, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FitnessTransactionsHistoryDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getTransactionHistory(tenantId, filter, withAggregations, sortBy, page, pageSize, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Gets all usc vouchers for an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listFitnessVouchers(tenantId: string, employeeId: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FitnessVoucherDTO>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listFitnessVouchers(tenantId, employeeId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * FitnessApi - factory interface
 * @export
 */
export const FitnessApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FitnessApiFp(configuration)
    return {
        /**
         * 
         * @summary Exports Fitness Members with according Acctions in CSV format
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCSV(options?: any): AxiosPromise<string> {
            return localVarFp.getCSV(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets one usc voucher for an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {string} voucherId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFitnessVoucher(tenantId: string, employeeId: string, voucherId: string, options?: any): AxiosPromise<FitnessVoucherDTO> {
            return localVarFp.getFitnessVoucher(tenantId, employeeId, voucherId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} tenantId 
         * @param {string} [filter] 
         * @param {boolean} [withAggregations] 
         * @param {Array<string>} [sortBy] 
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTransactionHistory(tenantId: string, filter?: string, withAggregations?: boolean, sortBy?: Array<string>, page?: number, pageSize?: number, options?: any): AxiosPromise<FitnessTransactionsHistoryDTO> {
            return localVarFp.getTransactionHistory(tenantId, filter, withAggregations, sortBy, page, pageSize, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all usc vouchers for an employee
         * @param {string} tenantId 
         * @param {string} employeeId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listFitnessVouchers(tenantId: string, employeeId: string, options?: any): AxiosPromise<Array<FitnessVoucherDTO>> {
            return localVarFp.listFitnessVouchers(tenantId, employeeId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for getFitnessVoucher operation in FitnessApi.
 * @export
 * @interface FitnessApiGetFitnessVoucherRequest
 */
export interface FitnessApiGetFitnessVoucherRequest {
    /**
     * 
     * @type {string}
     * @memberof FitnessApiGetFitnessVoucher
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof FitnessApiGetFitnessVoucher
     */
    readonly employeeId: string

    /**
     * 
     * @type {string}
     * @memberof FitnessApiGetFitnessVoucher
     */
    readonly voucherId: string
}

/**
 * Request parameters for getTransactionHistory operation in FitnessApi.
 * @export
 * @interface FitnessApiGetTransactionHistoryRequest
 */
export interface FitnessApiGetTransactionHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof FitnessApiGetTransactionHistory
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof FitnessApiGetTransactionHistory
     */
    readonly filter?: string

    /**
     * 
     * @type {boolean}
     * @memberof FitnessApiGetTransactionHistory
     */
    readonly withAggregations?: boolean

    /**
     * 
     * @type {Array<string>}
     * @memberof FitnessApiGetTransactionHistory
     */
    readonly sortBy?: Array<string>

    /**
     * 
     * @type {number}
     * @memberof FitnessApiGetTransactionHistory
     */
    readonly page?: number

    /**
     * 
     * @type {number}
     * @memberof FitnessApiGetTransactionHistory
     */
    readonly pageSize?: number
}

/**
 * Request parameters for listFitnessVouchers operation in FitnessApi.
 * @export
 * @interface FitnessApiListFitnessVouchersRequest
 */
export interface FitnessApiListFitnessVouchersRequest {
    /**
     * 
     * @type {string}
     * @memberof FitnessApiListFitnessVouchers
     */
    readonly tenantId: string

    /**
     * 
     * @type {string}
     * @memberof FitnessApiListFitnessVouchers
     */
    readonly employeeId: string
}

/**
 * FitnessApi - object-oriented interface
 * @export
 * @class FitnessApi
 * @extends {BaseAPI}
 */
export class FitnessApi extends BaseAPI {
    /**
     * 
     * @summary Exports Fitness Members with according Acctions in CSV format
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FitnessApi
     */
    public getCSV(options?: AxiosRequestConfig) {
        return FitnessApiFp(this.configuration).getCSV(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets one usc voucher for an employee
     * @param {FitnessApiGetFitnessVoucherRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FitnessApi
     */
    public getFitnessVoucher(requestParameters: FitnessApiGetFitnessVoucherRequest, options?: AxiosRequestConfig) {
        return FitnessApiFp(this.configuration).getFitnessVoucher(requestParameters.tenantId, requestParameters.employeeId, requestParameters.voucherId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {FitnessApiGetTransactionHistoryRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FitnessApi
     */
    public getTransactionHistory(requestParameters: FitnessApiGetTransactionHistoryRequest, options?: AxiosRequestConfig) {
        return FitnessApiFp(this.configuration).getTransactionHistory(requestParameters.tenantId, requestParameters.filter, requestParameters.withAggregations, requestParameters.sortBy, requestParameters.page, requestParameters.pageSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all usc vouchers for an employee
     * @param {FitnessApiListFitnessVouchersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FitnessApi
     */
    public listFitnessVouchers(requestParameters: FitnessApiListFitnessVouchersRequest, options?: AxiosRequestConfig) {
        return FitnessApiFp(this.configuration).listFitnessVouchers(requestParameters.tenantId, requestParameters.employeeId, options).then((request) => request(this.axios, this.basePath));
    }
}
